import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appInputtext]'
})
export class InputtextDirective {
  regexStr = '^[a-zA-Z ]*$';

  constructor(private el: ElementRef) { }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    return new RegExp(this.regexStr).test(event.key);
  }

  @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
    this.validateFields(event);
  }

  validateFields(event) {
    setTimeout(() => {

      this.el.nativeElement.value = this.el.nativeElement.value.replace(/[^A-Za-z ]/g, '')
      event.preventDefault();

    }, 100)
  }
}
